import { Fade, Tooltip } from '@mui/material';
import {
  ChatbotMessage,
  ChatbotAuthStatus,
  useChatbotControls,
  ChatbotSessionStatus,
} from '@shared/hooks';
import { useSharedTFunction } from '@shared/i18n';
import { ChatbotFab } from './ChatbotFab';
import { ChatbotChat } from './ChatbotChat';
import { ChatbotSquareTrigger } from './ChatbotSquareTrigger';

interface Props {
  messages: ChatbotMessage[];
  sendMessage: (text: string) => void;
  authStatus: ChatbotAuthStatus;
  sessionStatus: ChatbotSessionStatus;
  variant?: 'fab' | 'square';
}

export default function ChatBot({ variant = 'fab', ...props }: Props) {
  const t = useSharedTFunction();
  const { isOpen, initialMessage, toggleChat, closeChat } = useChatbotControls();

  return (
    <>
      {variant === 'fab' ? (
        <Tooltip placement="left" arrow title={t('shared.chatbot.askAda')}>
          <ChatbotFab onClick={toggleChat} sx={{ position: 'fixed', bottom: 16, right: 16 }} />
        </Tooltip>
      ) : (
        <Fade in={!isOpen} unmountOnExit>
          <ChatbotSquareTrigger
            onClick={toggleChat}
            sx={{ position: 'fixed', bottom: 100, right: 0 }}
          />
        </Fade>
      )}

      <Fade in={isOpen} unmountOnExit>
        <ChatbotChat
          {...props}
          initialMessage={initialMessage}
          onCloseChat={closeChat}
          sx={{ position: 'fixed', bottom: 80, right: 16 }}
        />
      </Fade>
    </>
  );
}
